<template>
  <div>
    <div class="map" id="mapScreen"></div>
    <div class="openWin" v-show="showFlag">
      <div class="iconBox">
        <span class="title">{{ windowTitle }}</span
        ><i class="el-icon-circle-close" id="close" @click="closeWin()"></i>
      </div>
      <div class="box">
        <p>
          <span class="label">安装位置：</span
          ><span class="value">{{ detail.location }}</span>
        </p>
        <p>
          <span class="label">设备状态：</span><span class="value">在线</span>
        </p>
        <p>
          <span class="label">设备电量：</span
          ><span class="value">{{ detail.dl }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import img1 from "@/assets/map/logo1.png";
import img2 from "@/assets/map/logo2.png";
import img3 from "@/assets/map/logo3.png";
import jk from "@/assets/satistics/img-enviromentdian.png";
import circleBg from "@/assets/map/cir.png";

export default {
  props: {
    latitude: {
      type: [Number],
      default: 31.511953,
    },
    longitude: {
      type: [Number],
      default: 120.618273,
    },
    zoom: {
      type: [Number],
      default: 15,
    },
    videoids: {
      default: [],
    },
  },
  data() {
    return {
      isMarker: false,
      map: "",
      geometries: [],
      jkLayer: "",
      flag: 1, //燃气烟感
      detail: {},
      windowTitle: "",
      showFlag: false,
      jkbg: "",
    };
  },
  watch: {
    videoids(val) {
      // if (val.length > 0) {
      // }
    },
  },
  mounted() {
    var map;
    var drawContainer = document.getElementById("mapScreen");
    var center = new TMap.LatLng(31.519506, 120.627906); //设置中心点坐标
    map = new TMap.Map(drawContainer, {
      zoom: 15,
      pitch: 40,
      center: center,
      draggable: true,
      scrollable: true,
      mapStyleId: "style 1",
    });

    // 隐藏控件
    map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ZOOM); // 比例尺控件
    map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.SCALE); // 比例尺控件
    map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ROTATION); // 旋转控件

    //路灯
    var markerLayer1 = new TMap.MultiMarker({
      map: map, //指定地图容器
      //样式定义
      styles: {
        //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
        myStyle: new TMap.MarkerStyle({
          width: 32, // 点标记样式宽度（像素）
          height: 32, // 点标记样式高度（像素）
          src: img1, //图片路径
          //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
          // "anchor": {x: 16, y: 32}
        }),
      },
      //点标记数据数组
      geometries: [
        {
          id: "1", //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
          styleId: "myStyle", //指定样式id
          position: new TMap.LatLng(31.52984, 120.614066), //点标记坐标位置
          data: {
            location: "江苏省苏州市相城区姚浜路龙翔驾校旁",
            status: "在线",
            dl: this.random(90, 100),
          },
        },
        {
          id: "2",
          styleId: "myStyle", //指定样式id
          position: new TMap.LatLng(31.518687, 120.623113), //点标记坐标位置
          data: {
            location: "苏州市好迪医疗器械有限公司(生态路)",
            status: "在线",
            dl: this.random(90, 100),
          },
        },
        {
          id: "3",
          styleId: "myStyle", //指定样式id
          position: new TMap.LatLng(31.527994, 120.618215), //点标记坐标位置
          status: "在线",
          data: {
            location: "相城区灵峰公园云峰休闲广场(灵福路西)",
            status: "在线",
            dl: this.random(90, 100),
          },
        },
      ],
    });
    //音柱
    var markerLayer2 = new TMap.MultiMarker({
      map: map, //指定地图容器
      //样式定义
      styles: {
        //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
        myStyle2: new TMap.MarkerStyle({
          width: 32, // 点标记样式宽度（像素）
          height: 32, // 点标记样式高度（像素）
          src: img2, //图片路径
          //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
          // "anchor": {x: 16, y: 32}
        }),
      },
      //点标记数据数组
      geometries: [
        {
          id: "1", //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
          styleId: "myStyle2", //指定样式id
          position: new TMap.LatLng(31.529859, 120.614138), //点标记坐标位置
          data: {
            location: "江苏省苏州市相城区姚浜路龙翔驾校旁",
            status: "在线",
            dl: this.random(90, 100),
          },
        },
        {
          id: "2",
          styleId: "myStyle2", //指定样式id
          position: new TMap.LatLng(31.518635, 120.623123), //点标记坐标位置
          data: {
            location: "苏州市好迪医疗器械有限公司(生态路)",
            status: "在线",
            dl: this.random(90, 100),
          },
        },
        {
          id: "3",
          styleId: "myStyle2", //指定样式id
          position: new TMap.LatLng(31.52804, 120.618248), //点标记坐标位置
          data: {
            location: "相城区灵峰公园云峰休闲广场(灵福路西)",
            status: "在线",
            dl: this.random(90, 100),
          },
        },
      ],
    });
    //LED
    var markerLayer3 = new TMap.MultiMarker({
      map: map, //指定地图容器
      //样式定义
      styles: {
        //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
        myStyle3: new TMap.MarkerStyle({
          width: 32, // 点标记样式宽度（像素）
          height: 32, // 点标记样式高度（像素）
          src: img3, //图片路径
          //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
          // "anchor": {x: 16, y: 32}
        }),
      },
      //点标记数据数组
      geometries: [
        {
          id: "1", //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
          styleId: "myStyle3", //指定样式id
          position: new TMap.LatLng(31.529853, 120.614186), //点标记坐标位置
          data: {
            location: "江苏省苏州市相城区姚浜路龙翔驾校旁",
            status: "在线",
            dl: this.random(90, 100),
          },
        },
        {
          id: "2",
          styleId: "myStyle3", //指定样式id
          position: new TMap.LatLng(31.518598, 120.623127), //点标记坐标位置
          data: {
            location: "苏州市好迪医疗器械有限公司(生态路)",
            status: "在线",
            dl: this.random(90, 100),
          },
        },
        {
          id: "3",
          styleId: "myStyle3", //指定样式id
          position: new TMap.LatLng(31.527995, 120.618275), //点标记坐标位置
          data: {
            location: "相城区灵峰公园云峰休闲广场(灵福路西)",
            status: "在线",
            dl: this.random(90, 100),
          },
        },
      ],
    });

    markerLayer1.on("click", this.fun1);
    markerLayer2.on("click", this.fun2);
    markerLayer3.on("click", this.fun3);

    if (this.videoids) {
      this.geometries.push(
        {
          id: "1",
          styleId: "myStyle4",
          position: new TMap.LatLng(31.51627, 120.622632),
          data: this.videoids[0],
        },
        {
          id: "2",
          styleId: "myStyle4",
          position: new TMap.LatLng(31.545908, 120.619054),
          data: this.videoids[1],
        },
        {
          id: "3",
          styleId: "myStyle4",
          position: new TMap.LatLng(31.541332, 120.607326),
          data: this.videoids[2],
        },
        {
          id: "4",
          styleId: "myStyle4",
          position: new TMap.LatLng(31.527819, 120.617755),
          data: this.videoids[3],
        },
        {
          id: "5",
          styleId: "myStyle4",
          position: new TMap.LatLng(31.516202, 120.622622),
          data: this.videoids[4],
        },
        {
          id: "6",
          styleId: "myStyle4",
          position: new TMap.LatLng(31.519506, 120.627906),
          properties: {
            title: "6",
          },
          data: this.videoids[5],
        },
        {
          id: "7",
          styleId: "myStyle4",
          position: new TMap.LatLng(31.528911, 120.618876),
          data: this.videoids[6],
        },
        {
          id: "8",
          styleId: "myStyle4",
          position: new TMap.LatLng(31.528088, 120.618261),
          data: this.videoids[7],
        },
        {
          id: "9",
          styleId: "myStyle4",
          position: new TMap.LatLng(31.527988, 120.617905),
          data: this.videoids[8],
        }
      );
      // // 监控圈
      // this.jkbg = new TMap.MultiMarker({
      //   map: this.map,
      //   styles: {
      //     default: new TMap.MarkerStyle({
      //       width: 92, // 宽度
      //       height: 92, // 高度
      //       anchor: {x: 46, y: 46}, // 锚点位置
      //       src: circleBg, // 标注点图片url或base64地址
      //       color: '#fff', // 标注点文本颜色
      //       size: 22, // 标注点文本文字大小
      //       offset: {x: 0, y: 16}, // 标注点文本文字基于direction方位的偏移属性
      //     }),
      //   },
      //   geometries: [
      //     {
      //       position: new TMap.LatLng(31.528467, 120.618461), // 标注点位置
      //       content: '4', // 标注点文本
      //     },
      //     {
      //       position: new TMap.LatLng(31.516220, 120.622543), // 标注点位置
      //       content: '2', // 标注点文本
      //     },
      //   ],
      // });
      //监控
      var markerCluster = new TMap.MarkerCluster({
        map: map, //指定地图容器
        enableDefaultStyle: false, // 关闭默认样式
        minimumClusterSize: 2, //最小聚合点数：2个
        zoomOnClick: true, //点击聚合数字放大展开
        gridSize: 30, //聚合算法的可聚合距离，即距离小于该值的点会聚合至一起，默认为60，以像素为单位
        averageCenter: true, //每个聚和簇的中心是否应该是聚类中所有标记的平均值
        maxZoom: 15, //采用聚合策略的最大缩放级别，若地图缩放级别大于该值，则不进行聚合，标点将全部被展开
        //样式定义
        styles: {
          //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
          myStyle4: new TMap.MarkerStyle({
            width: 32, // 点标记样式宽度（像素）
            height: 32, // 点标记样式高度（像素）
            src: jk, //图片路径
            //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
            // "anchor": {x: 16, y: 32}
          }),
        },
        //点标记数据数组
        geometries: this.geometries,
      });

      var clusterBubbleList = [];
      var markerGeometries = [];
      var marker = null;

      // 监听聚合簇变化
      markerCluster.on("cluster_changed", function (e) {
        // 销毁旧聚合簇生成的覆盖物
        if (clusterBubbleList.length) {
          clusterBubbleList.forEach(function (item) {
            item.destroy();
          });
          clusterBubbleList = [];
        }
        markerGeometries = [];

        // 根据新的聚合簇数组生成新的覆盖物和点标记图层
        var clusters = markerCluster.getClusters();
        clusters.forEach(function (item) {
          if (item.geometries.length > 1) {
            let clusterBubble = new ClusterBubble({
              map,
              position: item.center,
              content: item.geometries.length,
            });
            clusterBubble.on("click", () => {
              map.fitBounds(item.bounds);
            });
            clusterBubbleList.push(clusterBubble);
          } else {
            markerGeometries.push({
              position: item.center,
            });
          }
        });

        if (marker) {
          // 已创建过点标记图层，直接更新数据
          marker.setGeometries(markerGeometries);
        } else {
          // 创建点标记图层
          marker = new TMap.MultiMarker({
            map,
            styles: {
              default: new TMap.MarkerStyle({
                width: 32, // 点标记样式宽度（像素）
                height: 32, // 点标记样式高度（像素）
                src: jk, //图片路径
                anchor: {
                  x: 16,
                  y: 16,
                },
              }),
            },
            geometries: markerGeometries,
          });
        }
      });

      // 以下代码为基于DOMOverlay实现聚合点气泡
      function ClusterBubble(options) {
        TMap.DOMOverlay.call(this, options);
      }

      ClusterBubble.prototype = new TMap.DOMOverlay();

      ClusterBubble.prototype.onInit = function (options) {
        this.content = options.content;
        this.position = options.position;
      };

      // 销毁时需要删除监听器
      ClusterBubble.prototype.onDestroy = function () {
        this.dom.removeEventListener("click", this.onClick);
        this.removeAllListeners();
      };

      ClusterBubble.prototype.onClick = function () {
        this.emit("click");
      };

      // 创建气泡DOM元素
      ClusterBubble.prototype.createDOM = function () {
        var dom = document.createElement("div");
        dom.classList.add("clusterBubble");
        dom.innerText = this.content;
        dom.style.cssText = [
          "width: " + (40 + parseInt(this.content) * 2) + "px;",
          "height: " + (40 + parseInt(this.content) * 2) + "px;",
          "line-height: " + (40 + parseInt(this.content) * 2) + "px;",
        ].join(" ");

        // 监听点击事件，实现zoomOnClick
        this.onClick = this.onClick.bind(this);
        // pc端注册click事件，移动端注册touchend事件
        dom.addEventListener("click", this.onClick);
        return dom;
      };

      ClusterBubble.prototype.updateDOM = function () {
        if (!this.map) {
          return;
        }
        // 经纬度坐标转容器像素坐标
        let pixel = this.map.projectToContainer(this.position);

        // 使文本框中心点对齐经纬度坐标点
        let left = pixel.getX() - this.dom.clientWidth / 2 + "px";
        let top = pixel.getY() - this.dom.clientHeight / 2 + "px";
        this.dom.style.transform = `translate(${left}, ${top})`;

        this.emit("dom_updated");
      };

      window.ClusterBubble = ClusterBubble;

      this.jkLayer = markerCluster;
      this.jkLayer.on("click", this.markerLayer4);
    }

    // this.map.on("zoom", this.fun4)
  },
  beforeDestroy() {
    // this.jkLayer.setGeometries([])
    // this.jkbg.setGeometries([])
    // this.jkbg.setMap(null)
    // this.jkLayer.setMap(null)
  },
  methods: {
    // 设置中心点
    setCenter(lat, lng) {
      let that = this;
      console.log("更新中心点到:" + lat + "," + lng);
      const center = new TMap.LatLng(lat, lng);
      that.map.setCenter(center);
    },
    markerLayer4(res) {
      this.geometries.map((item) => {
        if (item.id == res.geometry.id) {
          this.$emit("handleView", item.data);
        }
      });
    },
    fun1(res) {
      this.windowTitle = "路灯";
      this.showFlag = true;
      this.detail = res.geometry.data;
    },
    fun2(res) {
      this.windowTitle = "音柱";
      this.showFlag = true;
      this.detail = res.geometry.data;
    },
    fun3(res) {
      this.windowTitle = "LED";
      this.showFlag = true;
      this.detail = res.geometry.data;
    },
    random(lower, upper) {
      // 包括下线数字（lower）也包括上限数字（upper）
      return Math.floor(Math.random() * (upper - lower + 1)) + lower;
    },
    closeWin() {
      this.showFlag = false;
      this.flag = 1;
    },
    fun4(res) {
      var zoomCurrent = this.map.getZoom();
      if (zoomCurrent >= 16) {
        this.jkbg.setMap(null);
      } else {
        this.jkbg.setMap(null);
        this.jkLayer.setMap(null);
        // 监控圈
        this.jkbg = new TMap.MultiMarker({
          map: this.map,
          styles: {
            default: new TMap.MarkerStyle({
              width: 92, // 宽度
              height: 92, // 高度
              anchor: { x: 46, y: 46 }, // 锚点位置
              src: circleBg, // 标注点图片url或base64地址
              color: "#fff", // 标注点文本颜色
              size: 22, // 标注点文本文字大小
              offset: { x: 0, y: 16 }, // 标注点文本文字基于direction方位的偏移属性
            }),
          },
          geometries: [
            {
              position: new TMap.LatLng(31.528467, 120.618461), // 标注点位置
              content: "4", // 标注点文本
            },
            {
              position: new TMap.LatLng(31.51622, 120.622543), // 标注点位置
              content: "2", // 标注点文本
            },
          ],
        });
        //监控
        this.jkLayer = new TMap.MultiMarker({
          map: this.map, //指定地图容器
          //样式定义
          styles: {
            //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
            myStyle4: new TMap.MarkerStyle({
              width: 32, // 点标记样式宽度（像素）
              height: 32, // 点标记样式高度（像素）
              src: jk, //图片路径
              //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
              // "anchor": {x: 16, y: 32}
            }),
          },
          //点标记数据数组
          geometries: this.geometries,
        });
        this.jkLayer.on("click", this.markerLayer4);
      }
    },
  },
};
</script>

<style>
.clusterBubble {
  border-radius: 50%;
  color: #fff;
  font-weight: 500;
  text-align: center;
  opacity: 0.88;
  background-image: linear-gradient(139deg, #4294ff 0%, #295bff 100%);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  position: absolute;
  top: 0px;
  left: 0px;
}
</style>
<style scoped lang="less">
.map {
  height: 100%;
  position: relative;
  width: 100%;
  z-index: 1;
}

.openWin {
  padding: 10px 15px;
  position: absolute;
  top: 5%;
  right: 5%;
  z-index: 1000;
  color: #fff;
  background-color: rgba(3, 28, 82, 0.7);
  border-radius: 4px;
  font-size: 16px;
  border: 1px solid #0a205c;
  min-width: 250px;

  .iconBox {
    width: 100%;
    color: #ffffff;
    display: flex;
    align-items: center;

    #close {
      text-align: right;
      font-size: 20px;
      flex-grow: 1;
    }

    .title {
      text-align: left;
      font-size: 18px;
    }
  }

  .box {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .label {
    display: inline-block;
    line-height: 28px;
  }
}
</style>
